import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = { class: "subheader" }
const _hoisted_3 = { class: "subheader-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "subheader-icon fal fa-users" }, null, -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-xl-12" }
const _hoisted_7 = { class: "panel" }
const _hoisted_8 = { class: "panel-hdr mt-2" }
const _hoisted_9 = { class: "float-left" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-plus-square" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-sm-block float-right ml-1" }, "Nueva", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "panel-container" }
const _hoisted_14 = { class: "panel-content mb-0 pb-0" }
const _hoisted_15 = { class: "row mb-2" }
const _hoisted_16 = { class: "col-xl-3 col-lg-3 col-md-3 col-sm-4 col-6" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "filtro_codigo_barras"
}, "Código de barras producto", -1)
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = { class: "input-group" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fal fa-barcode" })
  ])
], -1)
const _hoisted_21 = { class: "col-xl-3 col-lg-3 col-md-3 col-sm-4 col-6" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "filtro_nombre_producto"
}, "Nombre producto", -1)
const _hoisted_23 = { class: "table-responsive" }
const _hoisted_24 = { class: "table table-bordered table-sm" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center",
      style: {"width":"50px"}
    }, "#"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center"
    }, "Producto"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center",
      style: {"width":"150px"}
    }, "Cantidad"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center",
      style: {"width":"150px"}
    }, "P/Unitario"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center",
      style: {"width":"150px"}
    }, "Descuento"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center",
      style: {"width":"150px"}
    }, "Importe"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center",
      style: {"width":"30px"}
    })
  ])
], -1)
const _hoisted_26 = {
  scope: "row",
  class: "text-right",
  style: {"padding-top":"12px"}
}
const _hoisted_27 = { style: {"padding-top":"12px"} }
const _hoisted_28 = { class: "text-right" }
const _hoisted_29 = { class: "text-right" }
const _hoisted_30 = { class: "text-right" }
const _hoisted_31 = { class: "text-right" }
const _hoisted_32 = { class: "text-centar" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-trash-alt" }, null, -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  key: 0,
  class: "bg-warning-50"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("th", {
  scope: "row",
  class: "text-right",
  style: {"padding-top":"12px"}
}, "-", -1)
const _hoisted_38 = { style: {"padding-top":"12px"} }
const _hoisted_39 = { class: "text-right" }
const _hoisted_40 = { class: "text-right" }
const _hoisted_41 = { class: "text-right" }
const _hoisted_42 = { class: "text-right" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("td", { class: "text-centar" }, "   ", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("th", {
  scope: "row",
  colspan: "5",
  class: "text-right"
}, [
  /*#__PURE__*/_createElementVNode("h5", { class: "font-weight-bold" }, "TOTAL")
], -1)
const _hoisted_45 = { class: "text-right" }
const _hoisted_46 = { class: "font-weight-bold" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("td", { class: "text-centar" }, null, -1)
const _hoisted_48 = { class: "text-right mb-3" }
const _hoisted_49 = ["disabled"]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold" }, "$", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", {
  class: "page-content-overlay",
  "data-action": "toggle",
  "data-class": "mobile-nav-on"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select2 = _resolveComponent("Select2")!
  const _component_cobrar_venta_component = _resolveComponent("cobrar-venta-component")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.$router.currentRoute.value.meta.titleForm), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary btn-sm mr-2",
                  title: "Nueva venta",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.nuevaVenta && $setup.nuevaVenta(...args)))
                }, _hoisted_12)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _hoisted_20,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "filtro_codigo_barras",
                          name: "filtro_codigo_barras",
                          class: "form-control form-control-sm flex",
                          placeholder: "Buscar producto",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.filtroCodigoBarras) = $event)),
                          onKeypress: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => ($setup.buscarProducto && $setup.buscarProducto(...args)), ["enter"])),
                          ref: "filtroProductoRef"
                        }, null, 544), [
                          [
                            _vModelText,
                            $setup.filtroCodigoBarras,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createVNode(_component_Select2, {
                      id: "filtro_nombre_producto",
                      name: "filtro_nombre_producto",
                      options: $setup.productos,
                      "aria-placeholder": "Seleccione",
                      modelValue: $setup.filtroNombreProducto,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.filtroNombreProducto) = $event)),
                      settings: { multiple: false, placeholder: 'Seleccione', width: '100%', tags: false },
                      onSelect: $setup.asignarProductoSeleccionado
                    }, null, 8, ["options", "modelValue", "onSelect"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("table", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.ventasDetalle, (ventaDetalleItem, i) => {
                        return (_openBlock(), _createElementBlock("tr", { key: i }, [
                          _createElementVNode("th", _hoisted_26, _toDisplayString(i + 1), 1),
                          _createElementVNode("td", _hoisted_27, _toDisplayString(ventaDetalleItem.nombre_producto), 1),
                          _createElementVNode("td", _hoisted_28, _toDisplayString($setup.numeral(ventaDetalleItem.cantidad).format('0,0.00')), 1),
                          _createElementVNode("td", _hoisted_29, _toDisplayString($setup.numeral(ventaDetalleItem.precio_unitario).format('0,0.00')) + ".- ", 1),
                          _createElementVNode("td", _hoisted_30, _toDisplayString($setup.numeral(ventaDetalleItem.descuento).format('0,0.00')) + ".- ", 1),
                          _createElementVNode("td", _hoisted_31, _toDisplayString($setup.numeral(ventaDetalleItem.importe).format('0,0.00')) + ".- ", 1),
                          _createElementVNode("td", _hoisted_32, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-danger btn-xs",
                              title: "Eliminar",
                              onClick: ($event: any) => ($setup.eliminarDetalleFactura(i))
                            }, _hoisted_35, 8, _hoisted_33)
                          ])
                        ]))
                      }), 128)),
                      ($setup.ventaDetalle.id_producto > 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_36, [
                            _hoisted_37,
                            _createElementVNode("td", _hoisted_38, _toDisplayString($setup.ventaDetalle.nombre_producto), 1),
                            _createElementVNode("td", _hoisted_39, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                id: "cantidad",
                                name: "cantidad",
                                class: _normalizeClass(["form-control form-control-sm text-right", { 'is-invalid': $setup.vvd$.cantidad.$dirty && $setup.vvd$.cantidad.$invalid }]),
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.vvd$.cantidad.$model) = $event)),
                                onFocus: _cache[5] || (_cache[5] = ($event: any) => {$event.target.select();}),
                                onKeyup: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.calcularImporte && $setup.calcularImporte(...args))),
                                onKeypress: [
                                  _cache[7] || (_cache[7] = ($event: any) => ($setup.keyPressCantidad($event))),
                                  _cache[8] || (_cache[8] = _withKeys(
//@ts-ignore
(...args) => ($setup.adicionarDetalleVenta && $setup.adicionarDetalleVenta(...args)), ["enter"]))
                                ],
                                ref: "cantidadRef"
                              }, null, 34), [
                                [_vModelText, $setup.vvd$.cantidad.$model]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_40, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                id: "precio_unitario",
                                name: "precio_unitario",
                                class: _normalizeClass(["form-control form-control-sm text-right", { 'is-invalid': $setup.vvd$.precio_unitario.$dirty && $setup.vvd$.precio_unitario.$invalid }]),
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.vvd$.precio_unitario.$model) = $event)),
                                onKeyup: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => ($setup.calcularImporte && $setup.calcularImporte(...args))),
                                onKeypress: [
                                  _cache[11] || (_cache[11] = ($event: any) => ($setup.keyPressPrecioUnitario($event))),
                                  _cache[12] || (_cache[12] = _withKeys(
//@ts-ignore
(...args) => ($setup.adicionarDetalleVenta && $setup.adicionarDetalleVenta(...args)), ["enter"]))
                                ]
                              }, null, 34), [
                                [_vModelText, $setup.vvd$.precio_unitario.$model]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_41, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                id: "descuento",
                                name: "descuento",
                                class: _normalizeClass(["form-control form-control-sm text-right", { 'is-invalid': $setup.vvd$.descuento.$dirty && $setup.vvd$.descuento.$invalid }]),
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.vvd$.descuento.$model) = $event)),
                                onKeyup: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => ($setup.calcularImporte && $setup.calcularImporte(...args))),
                                onKeypress: _cache[15] || (_cache[15] = _withKeys(
//@ts-ignore
(...args) => ($setup.adicionarDetalleVenta && $setup.adicionarDetalleVenta(...args)), ["enter"]))
                              }, null, 34), [
                                [_vModelText, $setup.vvd$.descuento.$model]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_42, _toDisplayString($setup.numeral($setup.ventaDetalle.importe).format('0,0.00')) + ".- ", 1),
                            _hoisted_43
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("tr", null, [
                        _hoisted_44,
                        _createElementVNode("td", _hoisted_45, [
                          _createElementVNode("h5", _hoisted_46, _toDisplayString($setup.numeral($setup.total).format('0,0.00')) + ".-", 1)
                        ]),
                        _hoisted_47
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-warning btn-sm",
                      title: "Cobrar venta",
                      onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => ($setup.cobrarVenta && $setup.cobrarVenta(...args))),
                      disabled: $setup.ventasDetalle.length === 0,
                      accesskey: "c"
                    }, [
                      _hoisted_50,
                      _createTextVNode(" Cobrar [Atl + c] ")
                    ], 8, _hoisted_49)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _hoisted_51,
    _createVNode(_component_cobrar_venta_component, {
      ref: "cobrarVentaComponentRef",
      onCerrarCobrarVentaComponent: $setup.cerrarCobrarVentaComponentEmit
    }, null, 8, ["onCerrarCobrarVentaComponent"])
  ], 64))
}